import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { images } from '../data/links';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
export function Volumes() {
  return <section className="w-full bg-paper px-5 py-16 sm:py-24" aria-label="What you'll find inside" data-id="element-338" data-mp="1c5gr7r0f2dw9">
      <div className="mx-auto max-w-5xl" data-id="element-339" data-mp="1zv1mn9drb3mf">
        <SectionHeading eyebrow="What you’ll find inside" title="6 Premium Volumes to Help You Organize Pediatric Praxis & Motor Planning Cases" data-id="element-340" data-mp="1zw4dxiezr82v" />
        <img src={images.mockup} alt="Six volumes of the Praxis & Motor Planning Clinical Pathway" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-341" data-mp="1quwegx0qo177" />

        <div className="mt-10 space-y-6" data-id="element-342" data-mp="ff7sa7vb767g">
          {volumes.map(v => <article key={v.roman} className="overflow-hidden rounded-3xl bg-white ring-1 ring-line" data-id="element-343" data-mp="fhat7my02jqy">
              <div className="flex items-center gap-4 px-6 pt-6 sm:px-8 sm:pt-8" data-id="element-344" data-mp="kc812qjjmn29">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl font-heading text-xl font-bold text-white" style={{
              backgroundColor: v.color
            }} data-id="element-345" data-mp="3o8f1mao0t9my">
                  {v.roman}
                </span>
                <div data-id="element-346" data-mp="3t6gkauhjb6xw">
                  <p className="text-xs font-bold uppercase tracking-[0.14em]" style={{
                color: v.color
              }} data-id="element-347" data-mp="3t5ygncsjlqfy">
                    Volume {v.roman}
                  </p>
                  <h3 className="font-heading text-[1.35rem] font-semibold leading-tight text-ink sm:text-2xl" data-id="element-348" data-mp="61ilkygerr8q">{v.title}</h3>
                </div>
              </div>

              <div className="px-6 pb-6 pt-4 sm:px-8 sm:pb-8" data-id="element-349" data-mp="fsmy7rim300e">
                <p className="leading-relaxed text-ink/75" data-id="element-350" data-mp="ft4zx3o1m6fp">{v.intro}</p>

                <p className="mt-5 font-semibold text-ink" data-id="element-351" data-mp="tsxp2ujx8elk">{v.listLabel}</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-352" data-mp="pr2ndoy2vz79">
                  {v.list.map(item => <li key={item} className="flex gap-2.5 leading-snug text-ink/80" data-id="element-353" data-mp="wusj1h3y0fnb">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                  color: v.color
                }} aria-hidden="true" data-id="element-354" data-mp="11s12dl0tupq5" />
                      <span data-id="element-355" data-mp="16r58u3wda9cs">{item}</span>
                    </li>)}
                </ul>

                {v.extra && <>
                    <p className="mt-5 font-semibold text-ink" data-id="element-356" data-mp="1fkh4mjlwmjq0">{v.extraLabel}</p>
                    <ul className="mt-3 flex flex-wrap gap-2" data-id="element-357" data-mp="1fmlbnaf3nyui">
                      {v.extra.map(item => <li key={item} className="rounded-full bg-mist px-3 py-1.5 text-sm font-medium text-ink/80" data-id="element-358" data-mp="1pio9w56tzdc6">
                          {item.replace(/\.$/, '')}
                        </li>)}
                    </ul>
                  </>}

                {v.note && <p className="mt-5 text-[0.95rem] italic leading-relaxed text-ink/65" data-id="element-359" data-mp="3gnd9eu0bao">{v.note}</p>}
              </div>

              <div className="flex items-start gap-3 px-6 py-4 sm:px-8" style={{
            backgroundColor: `${v.color}14`
          }} data-id="element-360" data-mp="2de9ozzjrnkps">
                <TargetIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
              color: v.color
            }} aria-hidden="true" data-id="element-361" data-mp="28lypuywuo2ya" />
                <p className="leading-snug text-ink" data-id="element-362" data-mp="24ly2upvoqjfm">
                  <strong data-id="element-363" data-mp="1zmlhyaodjmfo">The goal:</strong> {v.goal}
                </p>
              </div>
            </article>)}
        </div>
        <SectionCta label="I want all 6 volumes" data-id="element-364" data-mp="2wbb1e5fngn3r" />
      </div>
    </section>;
}